import fetch from '../../utils/fetch';
import { getImage, API_ROUTES } from '../../utils/constants';
import { getUserToken } from '../../utils/helpers';

export const getAppImageAPI = (data) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return fetch({
    method: 'GET', customUrl: getImage, params: data, requestHeaders: headers, basic: false,
  });
};

export const getAppQuestionsAPI = () => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };

  return fetch({
    method: 'GET', route: API_ROUTES.APP_QUESTIONS, requestHeaders: headers, basic: false,
  });
};

export const getAppsAPI = (data) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };


  return fetch({
    method: 'GET', route: API_ROUTES.CREATE_APP, params: data, requestHeaders: headers, basic: false,
  });
};

export const getAppAPI = (data) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };


  return fetch({
    method: 'GET', route: API_ROUTES.CREATE_APP, params: data, requestHeaders: headers, basic: false,
  });
};


export const createAppAPI = (data) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  const formData = new FormData();
  Object.keys(data).forEach(key => formData.append(key, data[key]));
  return fetch({
    method: 'POST', route: API_ROUTES.CREATE_APP, data: formData, requestHeaders: headers, basic: false,
  });
};


export const updateAppAPI = ({ appId, data }) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  const formData = new FormData();
  Object.keys(data).forEach(key => formData.append(key, data[key]));
  return fetch({
    method: 'POST', route: `${API_ROUTES.CREATE_APP}/${appId}`, data: formData, requestHeaders: headers, basic: false,
  });
};
export const deleteAppAPI = (appId) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'DELETE', route: `${API_ROUTES.HIDE_APP}/${appId}`, requestHeaders: headers, basic: false,
  });
};

export const deleteApplicationAPI = (appId) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'DELETE', route: `${API_ROUTES.DELETE_APP}/${appId}`, requestHeaders: headers, basic: false,
  });
};



// WEBPACK FOOTER //
// ./src/reducers/create-app/api.js